import React from 'react';
import Sheet from 'react-modal-sheet';
import Terms from './Terms';
import useDialogA11y from '../hooks/useDialogA11y';

const TermsModal = ({ isOpen, onClose }) => {
	const dialogRef = useDialogA11y(isOpen, onClose);

	return (
		<Sheet isOpen={isOpen} onClose={onClose}>
			<Sheet.Container>
				<div
					ref={dialogRef}
					role="dialog"
					aria-modal="true"
					aria-labelledby="terms-modal-title"
				>
					<div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
						<h2 id="terms-modal-title" className="fs-16 fw-700 m-0">
							Terms and Conditions
						</h2>
						<button
							type="button"
							className="closeModal"
							onClick={onClose}
							aria-label="Close Terms and Conditions"
							style={{
								background: 'none',
								border: 'none',
								fontSize: '24px',
								fontWeight: 'bold',
								cursor: 'pointer',
								padding: '4px 10px',
								lineHeight: 1,
							}}
						>
							×
						</button>
					</div>
					<Sheet.Content>
						<Terms />
					</Sheet.Content>
				</div>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default TermsModal;
